module.exports = __webpack_public_path__ + "img/386.bb40c0e8.png";